export default {
  routeExtras: {
    'extras': 'Extras de la ruta',
    'extraInfo': 'Información adicional',
    'value': 'Valor',
    'clickToHighlightOnMap': 'Haga clic para resaltar en el mapa',
    'showAllOnMap': 'Mostrar todo en el mapa'
  }
}
